import { ShieldCheck, Cog, Award, Clock, Download } from "lucide-react";

const SailCollaboration = () => {
    return (
        <section className="py-24 bg-primary relative overflow-hidden">
            {/* Background Decor */}
            <div className="absolute top-0 right-0 w-1/3 h-full bg-accent/5 -skew-x-12 transform translate-x-1/2"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="flex flex-col lg:flex-row items-center gap-16">

                    {/* Brand/Logo Section */}
                    <div className="w-full lg:w-1/3 flex flex-col items-center">
                        <div className="bg-white p-8 rounded-3xl shadow-2xl mb-8 border border-white/10 group hover:scale-105 transition-transform duration-500 w-full max-w-[280px] aspect-square flex items-center justify-center">
                            <div className="relative w-full h-24 md:h-32">
                                <img
                                    src="/images/sail.jpg"
                                    alt="SAIL Logo"
                                    className="absolute inset-0 w-full h-full object-contain transition-all duration-500"
                                />
                            </div>
                        </div>
                        <div className="text-center">
                            <span className="text-accent font-bold tracking-[0.2em] uppercase text-xs mb-2 block">Strategic Partnership</span>
                            <h4 className="text-white text-xl font-heading font-semibold">SAIL – Uma Ispat</h4>
                        </div>
                    </div>

                    {/* Content Section */}
                    <div className="w-full lg:w-2/3 space-y-8">
                        <div className="space-y-4">
                            <h2 className="text-accent font-bold tracking-wide uppercase text-sm">Announcement</h2>
                            <h3 className="text-3xl md:text-5xl font-bold font-heading text-white leading-tight">
                                Consignment Agent-cum-Service Centre
                            </h3>
                            <p className="text-slate-400 text-lg leading-relaxed max-w-2xl">
                                Uma Ispat Private Limited has been entrusted with the role of Consignment Agent-cum-Service Centre by SAIL – Uma Ispat.
                                This collaboration marks a new chapter in our commitment to precision processing and dependable execution.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
                            <div className="flex items-start gap-4 p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                                <ShieldCheck className="text-accent shrink-0" size={24} />
                                <div>
                                    <h5 className="text-white font-bold mb-1">Compliance Driven</h5>
                                    <p className="text-slate-500 text-sm">Adhering to the highest standards of industrial operations and transparency.</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-4 p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                                <Cog className="text-accent shrink-0" size={24} />
                                <div>
                                    <h5 className="text-white font-bold mb-1">Structured Processing</h5>
                                    <p className="text-slate-500 text-sm">Leveraging our state-of-the-art facilities for precision execution.</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-4 p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                                <Award className="text-accent shrink-0" size={24} />
                                <div>
                                    <h5 className="text-white font-bold mb-1">Dependable Execution</h5>
                                    <p className="text-slate-500 text-sm">30+ Years of expertise ensuring timely and reliable service delivery.</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-4 p-5 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                                <Clock className="text-accent shrink-0" size={24} />
                                <div>
                                    <h5 className="text-white font-bold mb-1">Quick Turnaround</h5>
                                    <p className="text-slate-500 text-sm">Optimized logistics and processing cycles for faster project completion.</p>
                                </div>
                            </div>
                        </div>

                        <div className="pt-2 text-center lg:text-left">
                            <a
                                href="/downloads/uma-ispat-pamphlet.pdf"
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 rounded-full bg-accent px-8 py-3 font-medium text-primary shadow-lg transition-all hover:bg-white"
                            >
                                Download Brochure <Download size={18} />
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default SailCollaboration;
